import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=db11b4c8&scoped=true&"
import script from "./AdminApp.vue?vue&type=script&lang=js&"
export * from "./AdminApp.vue?vue&type=script&lang=js&"
import style0 from "./AdminApp.vue?vue&type=style&index=0&id=db11b4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db11b4c8",
  null
  
)

export default component.exports